import data from "../../../../../packages/react/src/Octicon/Octicon.docs.json";
import * as React from 'react';
export default {
  data,
  React
};